import { createAction, createActions } from 'redux-actions';
// import createAction from 'redux-actions/lib/createAction';
import {
    createAsyncActions,
    runAsyncWorkflow
  } from '../lib/reduxHelpers';
import { MobileTranslate, Book, Translation } from '../api';

export const { headerFooterHideAction } = createActions('HEADER_FOOTER_HIDE_ACTION');
export const { setBookPage } = createActions('SET_BOOK_PAGE');
export const { setBookCurrentPage } = createActions('SET_BOOK_CURRENT_PAGE');


export const [
    fetchPageContent,
    receivePageContent,
    fetchPageContentError
  ] = createAsyncActions(
    'BOOK_PAGE_CONENT',
    ({id}) => ({id}),
    ({ok, data}) => ({ ok, data })
  );
  
  export const bookPageContent = (id) => {
    const fetchPromise = MobileTranslate.fetchPageContent(id);
    
    return runAsyncWorkflow({
      fetch: fetchPageContent,
      receive: receivePageContent,
      error: fetchPageContentError
    }, fetchPromise);
  };

  export const [
    fetchBookPages,
    receiveBookPages,
    bookPagesError
  ] = createAsyncActions(
    'BOOK_PAGES',
    ({ id }) => ({ id }),
    ({ok, data}) => ({ok, data })
  );
  
  export const fetchStoryPages = (id) => {
    const fetchPagePromise = Book.fetchStoryPages(id);
  
    return runAsyncWorkflow(
      {
        fetch: fetchBookPages,
        receive: receiveBookPages,
        error: bookPagesError
      },
      fetchPagePromise
    );
  };

  export const [
    postUpdatePageContent,
    receiveUpdatePageContent,
    updatePageContentError
  ] = createAsyncActions(
    'UPDATE_PAGE_SINGLE_CONTENT',
    ({id, content}) => ({id, content}),
    ({ok, data}) => ({ok, data})
  );

  export const updateSinglePageContent =(id, content) => {
    const updatePageContentPromise = MobileTranslate.updatePageContent(id, content);

    return runAsyncWorkflow(
      {
        fetch: postUpdatePageContent,
        receive: receiveUpdatePageContent,
        error: updatePageContentError
      },
      updatePageContentPromise
    );
  }

  export const { confirmModalVisibleAct } = createActions('CONFIRM_MODAL_VISIBLE_ACT');

  export const [
    fetchPublish,
    receivePublish,
    fetchPublishError
  ] = createAsyncActions(
    'BOOK_PUBLISH',
    ({story, id}) => ({story, id}),
    ({ok, data}) => ({ ok, data })
  );
  
  export const publish = (story, id) => {
    const fetchPromise = MobileTranslate.publish(story, id);
    
    return runAsyncWorkflow({
      fetch: fetchPublish,
      receive: receivePublish,
      error: fetchPublishError
    }, fetchPromise);
  };

  export const [
    fetchStoryInfo,
    receiveStoryInfo,
    fetchStoryInfoError
  ] = createAsyncActions(
    'STORY_INFO',
    ({id}) => ({id}),
    ({ok, data}) => ({ ok, data })
  );
  
  export const fetchStoryInfoWorkFlow = (id, isTemplate = false) => {
    const fetchPromise = MobileTranslate.fetchStoryInfo(id, isTemplate);
    
    return runAsyncWorkflow({
      fetch: fetchStoryInfo,
      receive: receiveStoryInfo,
      error: fetchStoryInfoError
    }, fetchPromise);
  };

  export const [
    fetchSaveToDraft,
    receiveSaveToDraft,
    fetchSaveToDraftError
  ] = createAsyncActions(
    'SAVE_TO_DRAFT',
    ({id}) => ({id}),
    ({ok, message}) => ({ ok, message })
  );
  
  export const saveToDraft = (id) => {
    const fetchPromise = MobileTranslate.saveToDraft(id);
    
    return runAsyncWorkflow({
      fetch: fetchSaveToDraft,
      receive: receiveSaveToDraft,
      error: fetchSaveToDraftError
    }, fetchPromise);
  };

  export const [
    fetchDiscardDraft,
    receiveDiscardDraft,
    fetchDiscardDraftError
  ] = createAsyncActions(
    'DISCARD_DRAFT',
    ({id}) => ({id}),
    ({ok, data}) => ({ ok, data })
  );
  
  export const discardDraft = (id) => {
    const fetchPromise = MobileTranslate.discardDraft(id);
    
    return runAsyncWorkflow({
      fetch: fetchDiscardDraft,
      receive: receiveDiscardDraft,
      error: fetchDiscardDraftError
    }, fetchPromise);
  };

  export const [
    fetchUpdateStoryInfo,
    receiveUpdateStoryInfo,
    fetchUpdateStoryInfoError
  ] = createAsyncActions(
    'UPDATE_STORY_INFO',
    ({id, title, eng_title, synopsis}) => ({id, title, eng_title, synopsis}),
    ({ok, data}) => ({ ok, data })
  );
  
  export const updateStoryInfo = (id, title, eng_title, synopsis) => {
    const fetchPromise = MobileTranslate.updateStoryInfo(id, title, eng_title, synopsis);
    
    return runAsyncWorkflow({
      fetch: fetchUpdateStoryInfo,
      receive: receiveUpdateStoryInfo,
      error: fetchUpdateStoryInfoError
    }, fetchPromise);
  };

  export const [
    fetchCheckTranslationsMobileTranslate,
    receiveCheckTranslationsMobileTranslate,
    fetchCheckTranslationsMobileTranslateError
  ] = createAsyncActions(
    'CHECK_TRANSLATIONS_MOBILE_TRANSLATE',
    (slug, translateToLanguage) => ({ slug, translateToLanguage }),
    ({ data }) => ({ data })
  );
  
  export const fetchCheckTranslationsMobileTranslateWorkflow = (slug, translateToLanguage) => {
    const fetchPromise = MobileTranslate.fetchCheckTranslationsMobileTranslate(slug, translateToLanguage);
  
    return runAsyncWorkflow(
      {
        fetch: fetchCheckTranslationsMobileTranslate,
        receive: receiveCheckTranslationsMobileTranslate,
        error: fetchCheckTranslationsMobileTranslateError
      },
      fetchPromise,
      {
        slug,
        translateToLanguage
      }
    );
  };

  export const [
    fetchMobileTranslations,
    receiveMobileTranslations,
    fetchMobileTranslationsError
  ] = createAsyncActions(
    'MOBILE_TRANSLATIONS',
    (slug, translateToLanguage) => ({ slug, translateToLanguage }),
    ({ data }) => ({ data })
  );
  
  export const fetchMobileTranslationsWorkflow = (slug, translateToLanguage) => {
    const fetchPromise = Translation.mobileTranslate(slug, translateToLanguage);
  
    return runAsyncWorkflow(
      {
        fetch: fetchMobileTranslations,
        receive: receiveMobileTranslations,
        error: fetchMobileTranslationsError
      },
      fetchPromise,
      {
        slug,
        translateToLanguage
      }
    );
  };

  export const [
    fetchStoryMobileTraslatability,
    receiveStoryMobileTraslatability,
    fetchStoryMobileTraslatabilityError
  ]= createAsyncActions(
    'STORY_MOBILE_TRANSLATABILITY',
    (slug) => ({ slug }),
    ({ ok, data }) => ({ ok, data })
  );

  export const fetchStoryMobileTraslatabilityWorkflow = (slug) => {
    const fetchPromise = MobileTranslate.getStoryMobileTraslatability(slug);
  
    return runAsyncWorkflow(
      {
        fetch: fetchStoryMobileTraslatability,
        receive: receiveStoryMobileTraslatability,
        error: fetchStoryMobileTraslatabilityError
      },
      fetchPromise
    );
  };

  export const openOriginalBookReader = createAction('sw/OPEN_ORIGINAL_BOOK_READER');
  export const closeOriginalBookReader = createAction('sw/CLOSE_ORIGINAL_BOOK_READER');


  export const [
    fetchTransliteration,
    receiveTransliteration,
    fetchTransliterationError
  ]= createAsyncActions(
    'FETCH_TRANSLITERATION',
    (string, language) => ({ string, language }),
    ({ twords, itrans, inString }) => ({ twords, itrans, inString })
  );

  export const fetchTransliterationWorkflow = (string, language) => {
    const fetchPromise = MobileTranslate.fetchTransliteration(string, language);
  
    return runAsyncWorkflow(
      {
        fetch: fetchTransliteration,
        receive: receiveTransliteration,
        error: fetchTransliterationError
      },
      fetchPromise
    );
  };

  export const [
    fetchVarnamTransliteration,
    receiveVarnamTransliteration,
    fetchVarnamTransliterationError
  ]= createAsyncActions(
    'FETCH_VARNAM_TRANSLITERATION',
    (string, language) => ({ string, language }),
    ({ success, error, at, result, input }) => ({ success, error, at, result, input })
  );

  export const fetchVarnamTransliterationWorkflow = (string, language) => {
    const fetchPromise = MobileTranslate.fetchVarnamTransliteration(string, language);
  
    return runAsyncWorkflow(
      {
        fetch: fetchVarnamTransliteration,
        receive: receiveVarnamTransliteration,
        error: fetchVarnamTransliterationError
      },
      fetchPromise
    );
  };

  export const [
    fetchAi4BharatTransliteration,
    receiveAi4BharatTransliteration,
    fetchAi4BharatTransliterationError
  ]= createAsyncActions(
    'FETCH_AI4_BHARAT_TRANSLITERATION',
    (string, language) => ({ string, language }),
    ({ success, error, at, result, input }) => ({ success, error, at, result, input })
  );

  export const fetchAi4BharatTransliterationWorkflow = (string, language) => {
    const fetchPromise = MobileTranslate.fetchAi4BharatTransliteration(string, language);
  
    return runAsyncWorkflow(
      {
        fetch: fetchAi4BharatTransliteration,
        receive: receiveAi4BharatTransliteration,
        error: fetchAi4BharatTransliterationError
      },
      fetchPromise
    );
  };


  export const [
    fetchMTCoachmarkCount,
    receiveMTCoachmarkCount,
    fetchMTCoachmarkCountError
  ] = createAsyncActions(
    'MT_FETCH_COACHMARK_COUNT',
    (userId, phaseName) => ({userId, phaseName}),
    ({ok}) => ({ok})
  );
  
  export const fetchMobileTranslateCoachmarkCountWorkflow = (userId, phaseName) => {
    const fetchPromise = MobileTranslate.fetchMobileTranslateCoachmarkCount(userId, phaseName);
  
    return runAsyncWorkflow({
      fetch: fetchMTCoachmarkCount,
      receive: receiveMTCoachmarkCount,
      error: fetchMTCoachmarkCountError
    }, fetchPromise);
  }

  export const [
    fetchMobileTranslateCoachmarkCount,
    receiveMobileTranslateCoachmarkCount,
    fetchMobileTranslateCoachmarkCountError
  ] = createAsyncActions(
    'MT_UPDATE_COACHMARK_COUNT',
    (userId, phaseName) => ({userId, phaseName}),
    ({ok}) => ({ok})
  );
  
  export const updateMobileTranslateCoachmarkCountWorkflow = (userId, phaseName) => {
    const fetchPromise = MobileTranslate.updateMobileTranslateCoachmarkCount(userId, phaseName);
  
    return runAsyncWorkflow({
      fetch: fetchMobileTranslateCoachmarkCount,
      receive: receiveMobileTranslateCoachmarkCount,
      error: fetchMobileTranslateCoachmarkCountError
    }, fetchPromise);
  }

  export const [
    fetchAudioResponse,
    receiveAudioResponse,
    fetchAudioResponseError
  ] = createAsyncActions(
    'MT_FETCH_AUDIO_RESPONSE',
    (file, lang) => ({file, lang}),
    ({ok, data}) => ({ok, data})
  );
  
  export const fetchAudioResponseWorkflow = (file, lang) => {
    const fetchPromise = MobileTranslate.fetchAudioResponse(file, lang);
  
    return runAsyncWorkflow({
      fetch: fetchAudioResponse,
      receive: receiveAudioResponse,
      error: fetchAudioResponseError
    }, fetchPromise);
  }


// WEBPACK FOOTER //
// ./src/redux/allMobileTranslateActions.js